import PropTypes from 'prop-types';

function IconTools({
  fill = 'var(--primaryColor)',
  backgroundFill = 'var(--secondaryColor)',
}) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.0002 9.39993H3.2002V13.3999H4.0002V9.39993Z"
        fill={backgroundFill}
      />
      <path d="M7.1999 10.2H6.3999V14.2H7.1999V10.2Z" fill={backgroundFill} />
      <path
        d="M10.4001 8.99994H9.6001V12.3999H10.4001V8.99994Z"
        fill={backgroundFill}
      />
      <path d="M13.5998 11H12.7998V14.2H13.5998V11Z" fill={backgroundFill} />
      <path d="M16.8 8.59991H16V12.7999H16.8V8.59991Z" fill={backgroundFill} />
      <path
        d="M19.1998 3.39999H0.799805V5.39999H19.1998V3.39999Z"
        fill={backgroundFill}
      />
      <path
        d="M3.1979 14.9999H3.9979V14.1999H4.7999V8.5999H3.9979V7.7999H3.1979V8.5999H2.3999V14.1999H3.1979V14.9999ZM3.1999 9.3999H3.9999V13.3999H3.1999V9.3999Z"
        fill={fill}
      />
      <path
        d="M6.3981 15.7999H7.1981V14.9999H8.0001V9.39991H7.1981V8.59991H6.3981V9.39991H5.6001V14.9999H6.3981V15.7999ZM6.4001 10.1999H7.2001V14.1999H6.4001V10.1999Z"
        fill={fill}
      />
      <path
        d="M9.59781 13.9999H10.3978V13.1999H11.1998V8.19987H10.3978V7.39987H9.59781V8.19987H8.7998V13.1999H9.59781V13.9999ZM9.5998 8.99987H10.3998V12.3999H9.5998V8.99987Z"
        fill={fill}
      />
      <path
        d="M12.798 15.8H13.598V15H14.4V10.2H13.598V9.39996H12.798V10.2H12V15H12.798V15.8ZM12.8 11H13.6V14.2H12.8V11Z"
        fill={fill}
      />
      <path
        d="M15.9982 14.3998H16.7982V13.5998H17.6002V7.79985H16.7982V6.99985H15.9982V7.79985H15.2002V13.5998H15.9982V14.3998ZM16.0002 8.59985H16.8002V12.7998H16.0002V8.59985Z"
        fill={fill}
      />
      <path
        d="M0 2.59995V17.3999H20V2.59995H0ZM19.2 16.5999H0.8V6.19995H19.2V16.5999ZM19.2 5.39995H0.8V3.39995H19.2V5.39995Z"
        fill={fill}
      />
      <path d="M16.8179 3.99988H15.7739V4.79988H16.8179V3.99988Z" fill={fill} />
      <path d="M18.5582 3.99988H17.5142V4.79988H18.5582V3.99988Z" fill={fill} />
      <path d="M15.0782 3.99988H14.0342V4.79988H15.0782V3.99988Z" fill={fill} />
      <path d="M9.30385 3.99988H1.44385V4.79988H9.30385V3.99988Z" fill={fill} />
    </svg>
  );
}

IconTools.propTypes = {
  fill: PropTypes.string,
  backgroundFill: PropTypes.string,
};

export default IconTools;
